import React from 'react';

export default function MissionStatement() {
  return (
      <div className="mission-image">
        <div className="mission-text">
          <h2>Our Mission</h2>
          <hr></hr>
        <h5 style= {{ marginLeft: '100px', marginRight: '100px' }}>Instant Inventory is dedicated to meeting the home improvement needs to all customers. Whether you are a home owner, buisness owner, or looking for a hobby, we got what you need!</h5>
        </div>
      </div>
  );
}
